import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { get_detail } from "../../api/getMovie.js";
import { extractDetailData } from "../../utility/utility.js";
import { extractSeasonData } from "../../utility/utility.js";
import { getCollection, getSeason } from "../../api/apiSetUp.js";

export const getDetail = createAsyncThunk(
  "detail/getDetail",
  async (arg, { getState }) => {
    let { id, type } = arg;
    let langConfig = getState().apiUtility.apiUtility.langConfig;
    let genreList = getState().apiUtility.apiUtility[`${type}GenreList`];

    const getDetail_response = await get_detail(id, type);
    let formatResponse = extractDetailData(
      type,
      getDetail_response,
      langConfig,
      genreList,
      false
    );

    console.log(getDetail_response)
    console.log("BREAK")
    console.log(formatResponse)
    formatResponse["type"] = type;

    if (Object.keys(formatResponse).includes("belongs_to_collection") && formatResponse.belongs_to_collection) {
      try {
        const collectionData = await getCollection(
          formatResponse.belongs_to_collection.id
        );
        formatResponse.belongs_to_collection.parts = collectionData.parts.map(
          (item) => extractDetailData(type, item, langConfig, genreList, true)
        );
        formatResponse.belongs_to_collection.overview = collectionData.overview;
      } catch (err) {
        console.log("GetCollectionError: ", err);
      }
    }

    if (Object.keys(formatResponse).includes("seasons")) {
      let initialSeasonState = {
        seasonLoading: true,
        seasonError: false,
        seasonInfo: {},
      };
      for (let season of formatResponse.seasons){
        season.seasonDetail = initialSeasonState
      }
    }

    return formatResponse;
  }
);

export const getSeasonDetail = createAsyncThunk(
  "detail/getSeasonDetail",
  async (arg, { getState }) => {
    let { tvId, seasonNumber } = arg;
    const season_response = await getSeason(tvId, seasonNumber);
    let formatResponse = extractSeasonData(season_response);
    return formatResponse;
  }
);

const DetailSlice = createSlice({
  name: "detail",
  initialState: {
    detailList: {
      movList: {},
      tvList: {},
    },
    detailListLoading: true,
    detailListError: false,
  },
  reducers: {
    modifyDetailList: (state, action) => {
      const { type, id, payload } = action.payload;
      return {
        ...state,
        detailList: {
          ...state.detailList,
          [type]: { ...state.detailList[type], [id]: payload },
        },
      };
    },
    toggleListLoading: (state) => {
      return { ...state, detailListLoading: !state.detailListLoading };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDetail.pending, (state) => {
        state.detailListLoading = true;
        state.detailListError = false;
      })
      .addCase(getDetail.fulfilled, (state, action) => {
        let typeList = action.payload.type == "mov" ? "movList" : "tvList";
        let id = action.payload.id;
        state.detailList[typeList][id] = action.payload;
        state.detailListLoading = false;
        state.detailListError = false;
      })
      .addCase(getDetail.rejected, (state, action) => {
        state.detailListLoading = false;
        state.detailListError = action.error.message;
      })
      .addCase(getSeasonDetail.pending, (state, { meta }) => {
        let { tvId, seasonNumber } = meta.arg;
        let targetSeason = state.detailList.tvList[tvId].seasons.find(item => item.season_number == seasonNumber);
        let targetSeasonIdx = state.detailList.tvList[tvId].seasons.indexOf(targetSeason);
        state.detailList.tvList[tvId].seasons[targetSeasonIdx].seasonDetail = {
          seasonLoading: true,
          seasonError: false,
          seasonInfo: {},
        };
      })
      .addCase(getSeasonDetail.fulfilled, (state, action) => {
        let { tvId, seasonNumber } = action.meta.arg;
        let targetSeason = state.detailList.tvList[tvId].seasons.find(
          (item) => item.season_number == seasonNumber
        );
        let targetSeasonIdx =
          state.detailList.tvList[tvId].seasons.indexOf(targetSeason);
        state.detailList.tvList[tvId].seasons[targetSeasonIdx].seasonDetail = {
          seasonLoading: false,
          seasonError: false,
          seasonInfo: action.payload,
        };
      })
      .addCase(getSeasonDetail.rejected, (state, action) => {
        console.log(action.meta.arg)
        let { tvId, seasonNumber } = action.meta.arg;
        let targetSeason = state.detailList.tvList[tvId].seasons.find(
          (item) => item.season_number == seasonNumber
        );
        let targetSeasonIdx =
          state.detailList.tvList[tvId].seasons.indexOf(targetSeason);
        state.detailList.tvList[tvId].seasons[targetSeasonIdx].seasonDetail = {
          seasonLoading: false,
          seasonError: action.error.message,
        };
      });
  },
});

export const { modifyDetailList, toggleListLoading } = DetailSlice.actions;
export default DetailSlice.reducer;
